import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatatableConfig } from 'src/app/config/DatatableConfig';
import { IUsuarios, IUsuariosRes } from 'src/app/interfaces/usuarios';
import { PerfilamientoService } from 'src/app/services/perfilamiento/perfilamiento.service';
import { UsuariosService } from 'src/app/services/usuarios/usuarios.service';
import { UtilsFnService } from 'src/app/services/utils/utils-fn.service';

@Component({
  selector: 'app-view-mantenedor-usuario-inicio',
  templateUrl: './view-mantenedor-usuario-inicio.component.html',
  styleUrls: ['./view-mantenedor-usuario-inicio.component.scss']
})
export class ViewMantenedorUsuarioInicioComponent implements OnInit {
  dtOptions: DataTables.Settings = {}
  usuarios: IUsuarios[] = []
  renderTable: boolean = true
  popoverItems: Array<Object> = [
    {
      texto: 'Editar', 
      icono: 'bi-pencil-square'
    },
    {
      texto: 'Ver detalle', 
      icono: 'bi-eye',
      function: null
    },
    {
      texto: 'Eliminar', 
      icono: 'bi-trash'
    }
  ]
  usuarioCreado: string = ''
  usuarioEditado: string = "";
  error: string = "";
  dataUsuario: any = {};
  nombreUsuario: string = "";
  usuarioEliminar: number | null = null;
  cargaInicial: boolean = true

  constructor(
    private userService: UsuariosService,
    private router: Router,
    private _perfilamiento: PerfilamientoService,
    private spinner: NgxSpinnerService,
    private _utilsFn: UtilsFnService
  ) {
    const routerData = this.router.getCurrentNavigation()?.extras?.state?.['data']
    if(routerData?.usuarioModificado) {
      this.usuarioEditado = routerData.mensaje;
      setTimeout(() => {
        this.usuarioEditado = "";
      }, 15000);
    }
    if ( routerData?.infoUsuario && routerData?.usuarioCreado === true ) {
      this.usuarioCreado = routerData?.infoUsuario.username
      setTimeout(() => {
        this.usuarioCreado = ''
      }, 15000);
    } 
    this.obtenerListaUsuarios()
  }

  ngOnInit(): void {
    this.dtOptions = { ...DatatableConfig.dtOptionsWithPopOver };
    this.dtOptions.lengthMenu = [10, 20, 30, 40, 50];
    this.dtOptions.destroy = true;
    this.dataUsuario = this._perfilamiento.getUsuario();
  }

  switchUsuarioVigente(usuario: IUsuarios) {
    
    if(this.dataUsuario.usuarioId !== usuario.usuarioId) {
      usuario.estadoUsuario = !usuario.estadoUsuario;
      let body = {
        usuarioId: usuario.usuarioId,
        estado: usuario.estadoUsuario? 1 : 0,
        vigente: usuario.vigente? 1 : 0
      }
      this.userService.modificarEstadoYVigencia(body).subscribe({
        next: (res: any) => {
          if (res.error == null) {
            this.usuarioEditado = "El cambio de Vigencia se ha registrado correctamente.";
            setTimeout(() => {
              this.usuarioEditado = "";
            }, 15000);
          }
        }
      })
    }
  }

  crearUsuario() {
    this.router.navigate(['/usuario-crear']);
  }

  verDetalle(usuario: Object) {
    this.router.navigate(['/usuario-crear-seleccionar'], { state: { data: { infoUsuario: usuario, verDetalle: true } } })
  }
  editarUsuario(usuario: any): void {
    if(this.dataUsuario.usuarioId !== usuario.usuarioId) {
      this.router.navigate(['/usuario-editar'], { state: { data: { infoUsuario: usuario}}})
    }
  }
  validarEliminacionUsuario(usuario: any): void {
    if (this.dataUsuario.usuarioId !== usuario.usuarioId) {
      this.nombreUsuario = usuario.username;
      this.usuarioEliminar = usuario.usuarioId;
      $("#btn-eliminar").trigger("click");
    }
  }
  eliminarUsuario(): void {
    if (this.usuarioEliminar != null) {
      this.userService.eliminarUsuario(Number(this.usuarioEliminar)).subscribe({
        next:(res: any) => {
          if (res.error != null) {
            this.error = res.error;
            setTimeout(() => {
              this.error = "";
            }, 15000);
          } else {
            this.usuarioEditado = "Se ha eliminado con éxito el usuario " + this.nombreUsuario;
            setTimeout(() => {
              this.usuarioEditado = "";
            }, 15000);
            this.obtenerListaUsuarios();
          }
        }
      })
    }
  }

  reiniciarDt(idTabla: string, dtOptions: any): void {
    if ($.fn.dataTable.isDataTable(`#${idTabla}`)) {
      $(`#${idTabla}`).DataTable().destroy();
    }
    setTimeout(() => {
      $(`#${idTabla}`).DataTable(dtOptions);
    }, 100); 
  }

  obtenerListaUsuarios(): void {
    if ( this.cargaInicial ) {
      this.spinner.show()
    }
    setTimeout(() => {
      if ( this.renderTable ) {
        this.renderTable = false;
        this.reiniciarDt('tabla-usuarios', this.dtOptions)
      }
      this.renderTable = true;

      // Datatable serverside
      this.dtOptions.serverSide = true
      this.dtOptions.pageLength = 10
      this.dtOptions.processing = true
      this.dtOptions.ajax = (dataTablesParameters: any, callback) => { 
        let paramsTableBody = {
          pageSize: dataTablesParameters.length,
          pageNumber: (dataTablesParameters.start / dataTablesParameters.length)+1
        }
        const busquedaTabla: string = dataTablesParameters.search.value
        this._utilsFn.agregarLoader('tabla-usuarios')

        this.userService.getUsuarios(busquedaTabla, paramsTableBody.pageSize, paramsTableBody.pageNumber).subscribe(
          (res: IUsuariosRes) => {
            this.usuarios = res.listado
            this._utilsFn.eliminarLoader('tabla-usuarios')
            if ( this.cargaInicial ) {
              this.spinner.hide()
              this.cargaInicial = false
            }

            callback({
              recordsTotal: res.totalItems,
              recordsFiltered: res.totalItems,
              data:[]
            })
            this.ocultarElemento();
            this.ajustarColumna();
            
          }
        )
      }
    }, 200); // Asegurarse que cargue el DOM
    // Fin Datatable serverside
  }
  ocultarElemento() {
    if ( this.usuarios.length > 0 ) {
      setTimeout(() => {
        const emptyElement = document.querySelector('#tabla-usuarios_wrapper .dataTables_empty');
        emptyElement?.setAttribute('style', 'display: none');
      }, 50);
    }
  }
  ajustarColumna() {
    setTimeout(() => {
      $("#tabla-usuarios").DataTable().columns.adjust();
    }, 180);
  }

}
